import React from "react";
import comingSoonIMG from "../../images/image_coming_soon-min.png";
import comingSoonIMG_fr from '../../images/image_coming_soon-fr-min.png';
import comingSoonIMG_es from '../../images/image_coming_soon-es-min.png'
import MenuIcon from "@mui/icons-material/Menu";
import {Fade} from "@mui/material";
import {getAvailableTrims, PostcompareData, secondaryVehiclesTrims, setTrimVehiclesData} from "../../slices/vehicleSlice";
import store from "../../store";
import {currencyConverter} from "../../utility/methods";
import {trackVehicleLock} from "../GoogleTagManager.utils";
import PowerTrainType from "../Button/PowerTrainType";
import {isMobile} from "react-device-detect";

export function getVehicleImage(vehicle, Locale) {
    let vehicleImage = null;

    if (vehicle && vehicle?.media && Object.keys(vehicle?.media).length > 0) {
        const mediaCode = vehicle.media[Object.keys(vehicle.media)[0]];
        if (mediaCode && Object.keys(mediaCode).length > 0) {
            const angleShot = mediaCode[Object.keys(mediaCode)[0]];
            if (angleShot.url !== null && angleShot.url !== "" && angleShot.url !== "undefined") {
                vehicleImage = angleShot.url;
            }
        }
    }

    if (vehicleImage) {
        return (
            <React.Fragment>
                <div className={"vehicle-img-sec"}>
                    <div className={'vehicleSize'}>
                      <div className="vehicle-size ">
                          <img src={vehicleImage} className={'img-responsive'}
                               alt={vehicle.name || 'Vehicle Image'}/>
                      </div>
                        {!isMobile &&
                        <div className="powertrain-icon">
                            <PowerTrainType powertrain={vehicle?.powertrain}
                            />
                        </div>
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }

    let comingSoonImage = comingSoonIMG;
    if (Locale === 'fr-CA') {
        comingSoonImage = comingSoonIMG_fr;
    } else if (Locale === 'es-US') {
        comingSoonImage = comingSoonIMG_es;
    }

    return (
        <React.Fragment>
            {vehicle && <div className={"vehicle-img-sec"}>
                <div className={'vehicleSize'}>
                    <img src={comingSoonImage} className={'vehicle-size img-responsive'}
                         alt={vehicle?.description || 'Coming Soon'}/>
                </div>
            </div>}
        </React.Fragment>
    );
}

export function competitorLength(setPrimaryAndSecondaryVehicles) {
    const filteredVehicles = setPrimaryAndSecondaryVehicles.filter(vehicle => vehicle !== null);
    return filteredVehicles.length > 2;
}

export const handleChangeModalClose = (setOpenModal) => {
    setOpenModal(false)
}

export const formatDescription = (description) => {
    if (!description) return '';

    return description.charAt(0).toUpperCase() + description.slice(1);
}

const handleAlternateTrims = (trim, vehiclesTrim, setPrimaryAndSecondaryVehicles,vehicleIndex, dispatch, colorCode, setIsModalVisible) => {
    let changeSecondary = null;
    const secondariesVehicle = [];
    const filteredSecondaryVehicles = [];
    changeSecondary = vehiclesTrim
        .filter((trimCode) => trimCode.trim === trim?.trim)
        .map((vehicleCode) => vehicleCode?.code);
    setPrimaryAndSecondaryVehicles.map((vehicleCode) =>
            secondariesVehicle.push(vehicleCode?.code)
        );

    if (vehicleIndex >= 0 && vehicleIndex < secondariesVehicle.length) {
        secondariesVehicle[vehicleIndex] = changeSecondary[0];
    } else {
        secondariesVehicle.push(changeSecondary[0]);
    }
    secondariesVehicle.forEach((code) => {
        if (code !== undefined) {
            filteredSecondaryVehicles.push({ code: code });
        }
    });

    const data = {
        code: filteredSecondaryVehicles,
        exterior: colorCode
    }
    dispatch(PostcompareData(data)).then(() => {
        dispatch(setTrimVehiclesData([]));
        setIsModalVisible(false);
    });
}

const checkIccCode = (options) => {
    let iccCode= [];
    Object.entries(options).map(([key, option]) => {
        const code = option?.iccCode && option?.iccCode[0]?.substring(0, 5);
        if (iccCode !==null && !iccCode?.includes(code)) {
            iccCode.push(code);
        }
    })
    return iccCode[0];
}

export const showSingleFeature = (changeOption, locale, trimVehicles, setPrimaryAndSecondaryVehicles,vehicleIndex, dispatch, colorCode, setIsModalVisible, isLocked,vehicle, t) => {
    return (
        <React.Fragment>
            <div className="change-option-feature">
                <table>
                    <thead>
                    <tr>
                        <th className="description">{t("description")}</th>
                        <th className="price">{t("features.price")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {Object.entries(changeOption).map(([key, option]) => (
                        <React.Fragment>
                            <tr key={key}>
                                <td className="description">{formatDescription(option?.description)}</td>
                                <td className="price">{currencyConverter(option?.price, locale)}</td>
                            </tr>
                        </React.Fragment>
                    ))}
                    </tbody>
                </table>
            </div>
            {checkIccCode(changeOption) !== undefined && checkIccCode(changeOption) !== null && trimVehicles.length > 0 &&
                <div className="change-option-feature">
                <p className={"option-label"}> {t("features.otherTrims")}</p>
                <table>
                    <thead>
                    <tr>
                        <th className="description">{t("description")}</th>
                        <th className="price">{t("features.price")}</th>
                        <th className="select">{t("overview.changeSelectModal.select")}</th>

                    </tr>
                    </thead>
                    <tbody>
                    {checkIccCode(changeOption) !== null && trimVehicles && trimVehicles.map((trim, index) => (
                        <React.Fragment key={index}>
                            <tr>
                                <td className="description">{formatDescription(trim?.trim)}</td>
                                <td className="price">{currencyConverter(trim?.pricing?.msrp, locale)}</td>
                                <td className="price">
                                    <div className="radio-container">
                                        <input
                                            type="radio"
                                            name="trimSelection"
                                            value={trim?.code}
                                            onChange={() => handleAlternateTrims(trim, trimVehicles, setPrimaryAndSecondaryVehicles, vehicleIndex, dispatch, colorCode, setIsModalVisible)}
                                            disabled={isLocked && checkLockStatus(vehicle, isLocked, vehicleIndex)}
                                            style={{ cursor: "pointer" }}
                                        />
                                        {isLocked && checkLockStatus(vehicle, isLocked, vehicleIndex) && (
                                            <div className="custom-tooltip radio-tooltip">{t("features.vehicleLocked")}</div>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        </React.Fragment>
                    ))}

                    </tbody>
                </table>
            </div>}
        </React.Fragment>
    );
}

export function isImageNotAvailable(vehicle) {
    let image = null;

    if (vehicle && vehicle?.media && Object.keys(vehicle?.media).length > 0) {
        const mediaCode = vehicle.media[Object.keys(vehicle.media)[0]];
        if (mediaCode && Object.keys(mediaCode).length > 0) {
            const angleShot = mediaCode[Object.keys(mediaCode)[0]];
            if (angleShot.url !== null && angleShot.url !== "" && angleShot.url !== "undefined") {
                image = angleShot.url;
                return !!image?.includes('image_not_available');
            }
        }
    }
}

export function getCompetitorImages(vehicle, locale) {
    let image = null;
    let comingSoonImage = comingSoonIMG;

    if (vehicle && vehicle?.media && Object.keys(vehicle?.media).length > 0) {
        const mediaCode = vehicle.media[Object.keys(vehicle.media)[0]];
        if (mediaCode && Object.keys(mediaCode).length > 0) {
            const angleShot = mediaCode[Object.keys(mediaCode)[0]];
            if (angleShot.url !== null && angleShot.url !== "" && angleShot.url !== "undefined") {
                image = angleShot.url;

                return (
                    <React.Fragment>
                        <div className={`competitor-vehicle-images ${image?.includes('image_not_available') ? 'image-not-available' : ''}`}>
                            <div className="competitor">
                            <img src={image}
                                 className={'vehicle-size'}
                                 alt={vehicle.name || 'Vehicle Image'}
                                 style={image?.includes('image_not_available') ? { height: 100, width: 165, top: -7 } : null}
                            />
                            </div>
                            {!isMobile &&
                                <div className={`${image?.includes('image_not_available') ? 'powertrain-icon no-image-icon' : 'powertrain-icon'}`}>
                                    <PowerTrainType powertrain={vehicle?.powertrain}
                                    />
                                </div>
                            }
                        </div>
                    </React.Fragment>
                );
            }
        }

    }
    if (locale === 'fr-CA') {
        comingSoonImage = comingSoonIMG_fr;
    } else if (locale === 'es-US') {
        comingSoonImage = comingSoonIMG_es;
    }

    return (
        <React.Fragment>
            <div className={'competitor-vehicle-images'}>
                <img
                    src={vehicle && comingSoonImage}
                    className={'vehicle-size img-responsive-secondaries'}
                    alt={vehicle?.name || 'Coming Soon'}
                    style={{ height: 110, width: 165, top: -15 }}
                />
            </div>
        </React.Fragment>
    );
}

export const changePlaceholderStyle = ()=> {
    const inputElement = document.getElementById('feature-search-input');
    inputElement.classList.add('normal-placeholder');
}

export const resetPlaceholderStyle = () => {
    const inputElement = document.getElementById('feature-search-input');
    inputElement.classList.remove('normal-placeholder');
}

export const getSecondaryTrimCodes = () => {
    const state = store.getState();
    return secondaryVehiclesTrims(state);
};

export function setVehicleDetailStyles(fontSize, capitalize = false) {
    document.querySelectorAll('.vehicle-detail > div').forEach(text => {
        text.style.fontSize = fontSize;
        if (capitalize) {
            text.style.textTransform = 'capitalize';
        } else {
            text.style.textTransform = 'initial';
        }
    });
}

export function setOverviewPanelStyles() {
    document.querySelectorAll('.overviewPanel .vehicle-detail').forEach(div => {
        div.style.display = 'flex';
        div.style.top = '20px';
        div.style.textAlign = 'center';
        div.style.gap = '2px';
        div.style.width = 'fit-content';
        div.querySelectorAll('div').forEach(child => {
            child.style.fontSize = '15px';
            child.style.width = 'max-content';
            child.style.fontWeight = 'bold';
        });
        const overView = document.querySelector('.overView');
        overView.style.border = '1px solid #cccccc';
        overView.style.background = '#F1F0F0';
        overView.style.boxShadow = '0 -4px 8px -2px rgba(0,0,0,0.08)';
        document.querySelectorAll('.overviewPanel').forEach( child => {
            child.style.justifyContent = 'center';
        })
        const yearMakeDivs = div.querySelectorAll('.model-year-make');
        if (yearMakeDivs[0]) yearMakeDivs[0].style.width = 'max-content';
        if (yearMakeDivs[1]) yearMakeDivs[1].style.width = 'max-content';
        const trim = div.querySelector('.vehicle-trim');
        if (trim) trim.style.width = 'max-content';
        const primaryVehicle = document.querySelector('.primary-vehicle');
        if (primaryVehicle) primaryVehicle.style.width = '540px';
    });
}

export function resetOverviewPanelStyles(maxHeight) {
    document.querySelectorAll('.overviewPanel .vehicle-detail').forEach((div,idx) => {
        div.style.display = 'block';
        div.style.top = '';
        div.style.gap = '';
        div.style.width = '';
        div.style.top = idx !== 0 ? '10px' : '';
        div.style.fontWeight = 'normal';
        div.style.textAlign = 'left';
        div.style.width = '100%';
        div.querySelectorAll('div').forEach(child => {
            child.style.fontSize = '16px';
            child.style.minWidth = '';
            child.style.fontWeight = 'normal';
            child.style.textTransform = 'uppercase';
        });
        const yearMake = div.querySelector('.model-year-make');
        if (yearMake) {
            yearMake.style.width = '';
            yearMake.style.fontSize = '12px';
        }
        const yearMakeDivs = div.querySelectorAll('.model-year-make');
        if (yearMakeDivs[0]) yearMakeDivs[0].style.width = 'fit-content';
        if (yearMakeDivs[1]) yearMakeDivs[1].style.width = 'fit-content';
        if (yearMakeDivs[0]) yearMakeDivs[0].style.fontSize = '12px';
        if (yearMakeDivs[1]) yearMakeDivs[1].style.fontSize = '12px';
        const trim = div.querySelector('.vehicle-trim');
        const primaryVehicle = document.querySelector('.primary-vehicle');
        if (maxHeight) {
            if (trim) trim.style.width = 'fit-content';
        } else {
            if (trim) trim.style.width = '200px';
            if (primaryVehicle) primaryVehicle.style.width = 'auto';
        }
        trim.style.fontSize = '18px';
        const trimDivs = div.querySelectorAll('.vehicle-trim');
        if (trimDivs[0]) trimDivs[0].style.fontWeight = 'bold';
        if (trimDivs[1]) trimDivs[1].style.fontWeight = 'bold';
        if (trimDivs[1]) trimDivs[1].style.fontSize = '18px';
        document.querySelectorAll('.overviewPanel').forEach( child => {
            child.style.justifyContent = '';
        })
       if (maxHeight) document.querySelector('.competitor-vehicle-overview').style.height = '210px';
        const overView = document.querySelector('.overView');
        overView.style.border = '';
        overView.style.background = '';
        overView.style.boxShadow = '';
    });
}

export function addTrimSeparator() {
    const firstTrim = document.querySelector('.overviewPanel .vehicle-detail .vehicle-trim');
    if (firstTrim && !firstTrim.nextElementSibling?.classList?.contains('vehicle-separator')) {
        const separator = document.createElement('span');
        separator.textContent = '|';
        separator.className = 'vehicle-separator';
        separator.style.fontSize = '12px';
        separator.style.margin = '0 8px';
        firstTrim.insertAdjacentElement('afterend', separator);
    }
}

export function removeTrimSeparator() {
    const separator = document.querySelector('.overviewPanel .vehicle-detail .vehicle-separator');
    if (separator) {
        separator.remove();
    }
}

export function setImageStyles(transform = '', opacity = '', display = 'block') {
    document.querySelectorAll('.primary-vehicle img, .competitor-vehicle img').forEach(img => {
        if (!img.closest('.competitor-vehicle-overview')?.querySelector('.no-vehicle')) {
            img.style.transform = transform;
            img.style.opacity = opacity;
            img.style.display = display;
        }
    });
}

export const checkLockStatus = (vehicle, isLocked, vehicleIndex) => {
    const secondaryTrimCodes = getSecondaryTrimCodes();
    const hasDuplicates = secondaryTrimCodes?.filter(code => code === vehicle?.code).length > 1;
    const lockKey = vehicle?.code;

    if (hasDuplicates) {
        if (Array.isArray(isLocked[lockKey])) {
            return isLocked[lockKey].some(entry => entry.vehicleIndex === vehicleIndex && entry.lockStatus);
        }
    } else {
        if (Array.isArray(isLocked[lockKey])) {
            return isLocked[lockKey][0]?.lockStatus || false;
        }
    }
    return false;
};

export const getIccCode = (options, vehicle, dispatch) => {
    let iccCode = [];
    return Promise.all(
        Object.entries(options).map(([key, option]) => {
            const code = option?.iccCode && option?.iccCode[0]?.substring(0, 5);
            if (code !== undefined && iccCode !==null && !iccCode?.includes(code)) {
                iccCode?.push(code);
                return dispatch(getAvailableTrims({
                    vehicleCode: vehicle?.modelCode,
                    iccCode: code
                }));
            }
        })
    );
};

export const toggleLockStatus = (index, vehicle, isLocked, dispatch, storeLockedVehicles, compareGroup) => {
    const updatedIsLocked = { ...isLocked };
    const secondaryTrimCodes = getSecondaryTrimCodes();
    const lockKey = vehicle?.code;

    if (!updatedIsLocked[lockKey]) {
        updatedIsLocked[lockKey] = [];
    }

    const vehicleIndex = index;

    const hasDuplicates = secondaryTrimCodes.filter(code => code === vehicle?.code).length > 1;

    if (hasDuplicates) {
        const existingLock = updatedIsLocked[lockKey].find(entry => entry.vehicleIndex === vehicleIndex);

        if (existingLock) {
            updatedIsLocked[lockKey] = updatedIsLocked[lockKey].filter(entry => entry.vehicleIndex !== vehicleIndex);
        } else {
            const newLockEntry = {
                lockStatus: true,
                vehicle: vehicle?.code,
                vehicleIndex: vehicleIndex,
            };
            updatedIsLocked[lockKey].push(newLockEntry);
            trackVehicleLock(compareGroup)
        }
    } else {
        if (updatedIsLocked[lockKey].length > 0) {
            updatedIsLocked[lockKey] = [];
        } else {
            const newLockEntry = {
                lockStatus: true,
                vehicle: vehicle?.code,
                vehicleIndex: vehicleIndex,
            };
            updatedIsLocked[lockKey].push(newLockEntry);
            trackVehicleLock(compareGroup)
        }
    }

    dispatch(storeLockedVehicles(updatedIsLocked));
    sessionStorage.setItem("lockedInfo", JSON.stringify(updatedIsLocked));
};

export function getCompareGroupData(setPrimaryAndSecondaryVehicles, errorCode, compareGroup) {
    return {
        primaryVehicleDescription: setPrimaryAndSecondaryVehicles[0]?.description,
        secondaryOneVehicleDescription: setPrimaryAndSecondaryVehicles[1]?.description ?? null,
        secondaryTwoVehicleDescription: setPrimaryAndSecondaryVehicles[2]?.description ?? null,
        secondaryThreeVehicleDescription: setPrimaryAndSecondaryVehicles[3]?.description ?? null,
        primaryVehicleMSRP: setPrimaryAndSecondaryVehicles[0]?.pricing?.msrp,
        tenant: compareGroup?.tenant,
        language: compareGroup?.language,
        secondaryOneVehicleMSRP: setPrimaryAndSecondaryVehicles[1]?.pricing?.msrp ?? null,
        secondaryTwoVehicleMSRP: setPrimaryAndSecondaryVehicles[2]?.pricing?.msrp ?? null,
        secondaryThreeVehicleMSRP: setPrimaryAndSecondaryVehicles[3]?.pricing?.msrp ?? null,
        primaryVehicleYear: setPrimaryAndSecondaryVehicles[0]?.year,
        primaryVehicleTrim: setPrimaryAndSecondaryVehicles[0]?.trim,
        primaryVehicleMake: setPrimaryAndSecondaryVehicles[0]?.make,
        primaryVehicleModel: setPrimaryAndSecondaryVehicles[0]?.model,
        errorCode: errorCode
    };
}

export const showMobileNav = (navigateFeatures, vehicle,t,pathname,showNav,checked, handleToogleMenu, showMobileNav, vehicles) => {
    return (
        <div className="mobile-header">
            <div className="navbar-header" onClick={() => handleToogleMenu()}>
                <button className="toggle-button" >
                    <MenuIcon fontSize={"medium"}/>
                </button>
                <div className="icon-text">
                    {  pathname.includes('features') ? t("navigation.features") : t("navigation.photos")}
                </div>
            </div>
            {showNav && (
                <Fade
                    in={checked}
                    style={{ transformOrigin: "50% 50% 0" }}
                    {...(checked ? { timeout: 1000 } : {})}
                >
                    <nav className="mobile-nav">
                        <ul className="nav-list">
                            <li className="nav-item">
                                {
                                    pathname.includes('features') ?
                                        <button
                                            className={`menu-toggle-btn ${!vehicles?.length ? 'menu-toggle-btn-disabled' : ''}`}
                                            id={"nav-photo-button"}
                                            onClick={() => navigateFeatures()}
                                            disabled={!vehicles?.length}
                                        >
                                            {t("navigation.photos")}
                                        </button> :
                                        <button className={'menu-toggle-btn'} onClick={() => navigateFeatures()}>
                                            { t("navigation.features")}
                                        </button>

                                }
                            </li>
                            {!showMobileNav && <li className="nav-item">
                                <button className={'menu-toggle-btn'} id={"nav-new-compare"}
                                        onClick={() => vehicle()}>{t('navigation.compare')}</button>
                            </li>}
                        </ul>
                    </nav>
                </Fade>
            )}
        </div>
    )
}